import { axiosInstance } from 'boot/axios'
export function featured ({ commit, state }) {
  if (state.featured) return
  axiosInstance.get('/api/featured').then(({ data }) => commit('setFeatured', data))
}
export function categories ({ commit, state }) {
  if (state.categories) return
  axiosInstance.get('/api/categories').then(({ data }) => commit('setCategories', data))
}
